import { isEqual } from "lodash";
export const isEqualAddresses = (deliveryAddress, billingAddress) => {
    const extractRelevantFields = (address) => ({
        firstName: address?.firstName,
        lastName: address?.lastName,
        street: address?.street,
        postalCode: address?.postalCode,
        city: address?.city,
        phone: address?.phone,
        email: address?.email,
    });
    return isEqual(extractRelevantFields(deliveryAddress), extractRelevantFields(billingAddress));
};
